module.exports = __webpack_public_path__ + "static/media/index.fbae9c5a.scss";


//////////////////
// WEBPACK FOOTER
// ./src/views/dispute-log/index.scss
// module id = 716
// module chunks = 0